var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// elements/components/x-din-paper.ts
import { baseConfig } from "@adornis/config/baseConfig.js";
import { html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { ref } from "lit/directives/ref.js";
import { ChemistryLitElement } from "../../chemistry-lit-element.js";
import { css } from "../../directives/css.js";
import "./x-flex.js";
var XDinPaper = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this.margin = "0";
    this.showDebugOutline = false;
  }
  styles() {
    return [
      {
        ":host": {
          display: "flex",
          overflow: "hidden",
          flex: "none",
          position: "relative",
          breakInside: "avoid",
          breakBefore: "page",
          boxSizing: "border-box",
          outline: this.showDebugOutline && baseConfig.get("DEPLOYMENT") === "development" ? "1px solid" : "unset",
          "#wrapper": {
            minWidth: "0",
            minHeight: "0",
            height: "100%",
            overflow: "auto",
            "&::-webkit-scrollbar": { width: 0 }
          }
        },
        ":host([size=a4])": {
          width: "21cm",
          height: "29.7cm",
          "#rotation": { width: "100%", height: "100%", boxSizing: "border-box" },
          // print margin
          "#wrapper::after": {
            pointerEvents: "none",
            content: "''",
            position: "absolute",
            boxSizing: "border-box",
            top: "0",
            left: "0",
            height: "29.7cm",
            width: "21cm",
            border: "1px solid grey",
            "@media print": { display: "none" }
          }
        },
        ":host([size=a4][landscape])": {
          height: "29.7cm",
          width: "21cm",
          "#rotation": {
            width: "29.7cm",
            flexShrink: "0",
            height: "21cm",
            boxSizing: "border-box",
            transform: "rotate(90deg) translateY(-21cm)",
            transformOrigin: "top left"
          },
          "#wrapper::after": {
            width: "29.7cm",
            height: "21cm"
          }
        },
        ":host([size=a4][landscape][idontwanttobreakmyneck])": {
          height: "21cm",
          width: "29.7cm",
          "#rotation": {
            height: "21cm",
            width: "29.7cm",
            transform: "none"
          }
        }
      }
    ];
  }
  get fits() {
    if (!this._wrapper)
      throw new Error("asking too early if page fits. Wait for render with `this.updateComplete`.");
    return this._wrapper.scrollHeight <= this._wrapper.clientHeight;
  }
  render() {
    return html`
      <div id="rotation" ${css({ padding: this.margin })}>
        <div id="wrapper" flex ${ref((wrapper) => this._wrapper = wrapper)}>
          <slot></slot>
        </div>
      </div>
    `;
  }
};
__decorateClass([
  property()
], XDinPaper.prototype, "margin", 2);
__decorateClass([
  property({ attribute: "show-debug-outline", type: Boolean })
], XDinPaper.prototype, "showDebugOutline", 2);
XDinPaper = __decorateClass([
  customElement("x-din-paper")
], XDinPaper);
export {
  XDinPaper
};
